import { render, staticRenderFns } from "./RoleAccountAssignDialog.vue?vue&type=template&id=0ad647ed&scoped=true&"
import script from "./RoleAccountAssignDialog.vue?vue&type=script&lang=js&"
export * from "./RoleAccountAssignDialog.vue?vue&type=script&lang=js&"
import style0 from "./RoleAccountAssignDialog.vue?vue&type=style&index=0&id=0ad647ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad647ed",
  null
  
)

export default component.exports